import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedSupervisors } from '@hooks/mocks/supervisors'
import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

interface IResources {
  code: string
  description: string
  id: number
  isActive: boolean
}

interface ISupervisor {
  code?: string
  description: string
  id: number
  isActive: boolean
  projectIds: number[]
  resourceIds: number[]
  resources: IResources[]
}

export const useFindSiteSupervisors = () => {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  const fetchSiteSupervisors = async () => {
    if (!isMockEnvironment) {
      const url = `sites/${siteId}/supervisors`
      const { data } = await api.get<ISupervisor[]>(url)
      return data
    }
    return mockedSupervisors
  }

  return useQuery({ queryKey: ['SUPERVISORS'], queryFn: fetchSiteSupervisors })
}
